import React from 'react'
import UpdateUserForm from './UpdateUserForm'
import './index.scss'

const UpdateUser = ({
	userId,
	setUpdateUser,
	setUpdateUserSuccess,
	updateUserSuccess,
	listUsers,
}) => {
	return (
		<>
			<UpdateUserForm
				userCode={userId}
				setUpdateUser={setUpdateUser}
				setUpdateUserSuccess={setUpdateUserSuccess}
				updateUserSuccess={updateUserSuccess}
				listUsers={listUsers}
			/>
		</>
	)
}

export default UpdateUser
